module.exports = __webpack_public_path__ + "static/img/08.08fdba5b.jpg";